import React from 'react'
import PropTypes from 'prop-types'
import { Center } from '@chakra-ui/react'

const ListOrEmpty = (props) => {
    return (<>
        {props.list?.length === 0 ? (
            <Center w="100%" p="5" bg="white" textAlign={"center"}>
                No {props.listName} found.
            </Center>
        ) : props.children}
    </>)
}

ListOrEmpty.propTypes = {
    list: PropTypes.arrayOf(PropTypes.any),
    listName: PropTypes.string
}

export default ListOrEmpty

